/** 异步引入百度地图 API */
export const InitBmap = (ak) => {
  return new Promise((resolve, reject) => {
    window.init = function () {
      console.log('地图API加载完成')
      resolve(true)
    }
    if (typeof window.BMapGL !== 'undefined') resolve(true)
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `//api.map.baidu.com/api?v=1.0&&type=webgl&ak=${ak}&callback=init`
    script.onerror = reject
    document.head.appendChild(script)
  })
}